module.exports = __webpack_public_path__ + "static/img/shiziwang1.99dbe241.png";